import { PageOptions } from "@global/Layout";
import getTextColor, { TextColors } from "./getTextColor";

interface Parameters {
  textColor: TextColors;
  logoOnlyHeader?: "default" | "logo_only";
  useLeadForm?: "on" | "off";
}

// Output function that passes processed options to functions and returns results as object keys
export default function parsePageOptions(options: Parameters) {
  return {
    text: getTextColor(options?.textColor),
    logoOnly: options?.logoOnlyHeader === "logo_only" ? true : false,
    useLeadForm: options?.useLeadForm === "on" ? true : false,
  };
}

// Middleman function that checks values for being undefined and assigns default value for fallback, then passes proccessed options to output function
export function processPageOptions(configs: PageOptions) {
  const processedOptions = {
    navTextColor:
      configs?.page_options__nav_text_color?.value[0]?.codename ?? "teal",
    headerLogoOnly:
      configs?.page_options__logo_only_header?.value[0]?.codename ?? "default",
    useLeadForm:
      configs?.page_options__lead_form_controller?.value[0]?.codename ?? "on",
  };

  return parsePageOptions({
    textColor: processedOptions.navTextColor,
    logoOnlyHeader: processedOptions.headerLogoOnly,
    useLeadForm: processedOptions.useLeadForm,
  });
}
